import type { IconSvgObject } from './types';

const Progress02Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 12C19.2761 12 19.5017 11.7759 19.4833 11.5004C19.429 10.6864 19.2421 9.88562 18.9291 9.12989C18.5522 8.21995 17.9997 7.39315 17.3033 6.69671C16.6069 6.00028 15.7801 5.44783 14.8701 5.07092C14.1144 4.75788 13.3136 4.57102 12.4996 4.51668C12.2241 4.49828 12 4.72387 12 5.00002L12 11.5C12 11.7762 12.2239 12 12.5 12H19Z", fill: "currentColor", key: "1" }]
];

export default Progress02Icon;
